import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

export interface Props {
  classNames?: string[]
  status?: 'default' | 'warning' | 'error' | 'success'
}

const StatusDot = ({classNames, status = 'default'}: Props) => (
  <span className={cn('StatusDot', {[`status-${status}`]: true}, classNames)} />
)

export default StatusDot
